import { combineReducers } from 'redux';

import empresa from './empresa';
import usuario from './usuario';
import pedido from './pedido';
import accessToken from './accessToken';
import sideMenuOpen from './sideMenuOpen';


export default combineReducers({
  accessToken,
  empresa,
  usuario,
  pedido,
  sideMenuOpen,
});
